import request from '@/utils/request'

export function getHomeCategory() {
    return request({
        url: '/ich/project/pc/home/data',
        method: 'get',
    })
}
